import { Modelo } from '@ext/index';
import moment, { Moment } from 'moment';

export class Stock extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }


    public Deposito: string = '';
    public Nave: string = '';
    public Zona: string = '';
    public Piso: string = '';
    public Estante: string = '';
    public Columna: string = '';
    public Fila: string = '';
    public Ubicacion: string = '';
    public Despacho: string = '';
    public Cantidad: number = 0;

    public set(): boolean
    {

        this.Deposito = !this.Json.deposito ? '': this.Json.deposito;
        this.Nave = !this.Json.nave ? '': this.Json.nave;
        this.Zona = !this.Json.zona ? '' : this.Json.zona;
        this.Piso = !this.Json.piso ? '' : this.Json.piso;
        this.Estante = !this.Json.estante ? '' : this.Json.estante;
        this.Columna = !this.Json.columna ? '' : this.Json.columna;
        this.Fila = !this.Json.fila ? '': this.Json.fila;
        this.Ubicacion = !this.Json.ubicacion ? '': this.Json.ubicacion;
        this.Despacho = !this.Json.despacho ? '': this.Json.despacho;
        this.Cantidad = !this.Json.cantidad ? 0 : this.Json.cantidad;

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: Stock )
    {
        this.Model = Model;
    }

    public Model: Stock;
}